export default __webpack_public_path__ + "static/media/joomla.54253c40.svg";